import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BlogService } from 'src/app/blog.service';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { LandingPage } from 'src/app/landing-page.model';
import { environment } from 'src/environments/environment';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, AfterViewInit, OnDestroy {

  pageCode: string;
  pageData: LandingPage;
  pageLoading = true;
  pageError = false;
  browserMode = false;
  navigationSub: Subscription;

  environment = environment;

  constructor(
    private metaSetter: MetaSetterService,
    private blogService: BlogService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: string,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.pageCode = this.router.url.slice(1);
    console.log("pageCode = " + this.pageCode)

    this.browserMode = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.loadPageData();
  }

  ngAfterViewInit(): void {
    this.navigationSub =
    
    this.router.events
    .pipe(
      filter(event => event instanceof NavigationStart),
      map(event => event as NavigationStart),  // appease typescript
      filter(event => event.url !== '/' + this.pageCode)
    )
    .subscribe(
      event => {
        this.pageCode = event.url.slice(1);

        this.loadPageData();
      }
    );
  }

  loadPageData(): void {
    this.pageLoading = true;
    this.pageError = false;

    this.blogService.getBuilderPage(this.pageCode)
      .subscribe(data => this.postPageFetch(data), () => {
        this.pageError = true;
      });
  }

  postPageFetch(data: LandingPage): void {
    this.pageData = data;
    this.metaSetter.setMeta({
      title: data.title_tag,
      seoTitle: data.seo_title,
      description: data.seo_description,
      metaImageURL: data.seo_thumbnail?.url || environment.defaultMetaImage,
      canonicalURL: `${environment.canonicalDomain}/${this.pageCode.toLowerCase()}`,
    });
    this.pageLoading = false;

    //set breadcrumb to title_tag
    this.breadcrumbService.set('@landingPageTitle', data.title_tag);
  }

  ngOnDestroy() {
    this.navigationSub.unsubscribe();
  }

}
